import { Vector3 } from "three";
import React, { useEffect, useState } from "react";
import Paneel from "../../doors/paneel";
import Schuif from "../../doors/schuif";
import { ConfigurationProps } from "../../Door";
import { useConfigurationOptionsContext } from "../../../../../app/providers/DoorOptionsProvider";

interface DoubleTaatsDoublePanelProps extends ConfigurationProps {}
const DoubleTaatsDoublePanel: React.FC<DoubleTaatsDoublePanelProps> = ({
  materials,
  position,
  rotation,
  scale,
  doorSettings,
}: DoubleTaatsDoublePanelProps) => {
  const position0 = new Vector3(-0.459, 0, 0);
  const position1 = new Vector3(0.459, 0, 0);
  const position2 = new Vector3(1.377, 0, 0);
  const position3 = new Vector3(2.295, 0, 0);

  const { eigenwijs, getConfigurationPositions } =
    useConfigurationOptionsContext();

  const [positions, setPositions] = useState<Vector3[]>([]);

  useEffect(() => {
    setPositions(
      getConfigurationPositions([position0, position1, position2, position3])
    );
  }, [eigenwijs?.sizeObjects]);

  return (
    <group position={position} scale={scale}>
      <Schuif
        materials={materials}
        position={positions[0]}
        index={0}
        frameSettings={doorSettings?.main?.frameSettings}
        railSettings={doorSettings?.main?.railSettings}
      />
      <Paneel
        materials={materials}
        position={positions[1]}
        index={1}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
      <Paneel
        materials={materials}
        position={positions[2]}
        index={2}
        frameSettings={doorSettings?.secondary?.frameSettings}
      />
      <Schuif
        materials={materials}
        position={positions[3]}
        rotation={rotation}
        index={3}
        frameSettings={doorSettings?.quaternary?.frameSettings}
        railSettings={doorSettings?.quaternary?.railSettings}
      />
    </group>
  );
};

export default DoubleTaatsDoublePanel;
